import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white border-b border-gray-100" : "bg-white"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 cursor-pointer">
            <img
              src="https://cdn11.bigcommerce.com/s-xkucyvxj20/images/stencil/original/onestopclearanceshop_350_x_50_1669484556__30640.original.png"
              alt="OneStopClearanceShop"
              className="h-9 w-auto object-contain"
            />
          </Link>

          {/* Desktop nav links */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-sm font-medium text-gray-700 hover:text-red-600 transition-colors cursor-pointer whitespace-nowrap">
              Home
            </Link>
            <a href="#inventory" className="text-sm font-medium text-gray-700 hover:text-red-600 transition-colors cursor-pointer whitespace-nowrap">
              Inventory
            </a>
            <a href="#about" className="text-sm font-medium text-gray-700 hover:text-red-600 transition-colors cursor-pointer whitespace-nowrap">
              About
            </a>
          </div>

          {/* Call or Text button */}
          <div className="flex items-center gap-3">
            {/* Full button on desktop */}
            <a
              href="tel:678-936-5391"
              className="hidden md:flex items-center gap-2 bg-red-600 text-white text-sm font-bold px-5 py-2.5 rounded-lg hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-base"></i>
              Call or Text 678-936-5391
            </a>

            {/* Icon-only button on mobile */}
            <a
              href="tel:678-936-5391"
              className="md:hidden flex items-center justify-center w-10 h-10 bg-red-600 text-white rounded-full hover:bg-red-700 transition-colors cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
            </a>

            {/* Mobile hamburger */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <i className={`text-gray-700 text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-3">
          <Link to="/" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Home</Link>
          <a href="#inventory" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Inventory</a>
          <a href="#about" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-gray-700 hover:text-red-600 transition-colors cursor-pointer">About</a>
          <a
            href="tel:678-936-5391"
            className="flex items-center gap-2 bg-red-600 text-white text-sm font-bold px-4 py-2.5 rounded-lg w-fit mt-1 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            Call or Text 678-936-5391
          </a>
        </div>
      )}
    </nav>
  );
}
